import React from "react";
import { Card } from "reactstrap";
import styled from "styled-components";

const AgentTeamsCard = ({ member, ...props }) => {
    const {
        dIAgentPic,
        agentUri,
        agentName,
        nickName,
        hideWebsite,
        brokerAgentTitleInfo,
        brokerageName,
    } = member;
    const CardTag = hideWebsite ? "div" : "a";
    const linkProps = hideWebsite ? {} : { href: `/agents/${agentUri}` };
    const hasLink = CardTag === "a";

    return (
        <AgentCard
            {...props}
            tag={CardTag}
            {...linkProps}
            hasLink={hasLink}
            className="p-3 mb-3 rounded shadow border-0 text-dark h-100 nounderline"
        >
            <div className="d-flex flex-row">
                <div className="member-photo me-3 align-content-center">
                    <img
                        src={dIAgentPic.imageUrl}
                        alt={`${agentUri}-team-photo`}
                    />
                </div>

                <div className="card-text w-100">
                    <h3 className="h4">{nickName || agentName}</h3>
                    <div>{`${brokerAgentTitleInfo?.part1} ${brokerAgentTitleInfo?.part2}`}</div>
                    <div>{brokerageName}</div>
                </div>
            </div>
        </AgentCard>
    );
};

const AgentCard = styled(Card)`
    break-inside: avoid-column;
    ${({ hasLink }) =>
        hasLink &&
        `
            &:hover {
                background-color: var(--bs-gray-200);
                transition: background-color 0.2s ease-in-out;
            }
        `}

    .card-text {
        overflow-wrap: anywhere;
    }

    .member-photo {
        height: 140px;
        width: 110px;
        > img {
            max-height: 130px;
            max-width: 100px;
        }
    }
`;

export default AgentTeamsCard;
